import React from 'react';
import { OnboardingTip } from '../tip/onboarding-tip';
import { Headline } from '../../headline/headline';

interface StepTextContentProps {
    content: {
        headline?: string;
        text: string;
        tips?: React.ReactNode[];
    };
}

export const StepTextContent: React.FC<StepTextContentProps> = ({ content }) => {
    return (
        <>
            {content.headline && (
                <Headline level={3} tag={'div'} gap={'vsmall'} marginTop={'none'}>
                    {content.headline}
                </Headline>
            )}
            {content.text}
            {content.tips && Object.values(content.tips).length > 0 && (
                <div className="mt-medium flex flex-col items-center gap-xsmall">
                    {Object.values(content.tips).map((tip, index) => (
                        <OnboardingTip key={index} content={tip} />
                    ))}
                </div>
            )}
        </>
    );
};
